"use client"

import { atomWithStorage } from 'jotai/utils'

// `getOnInit: true` makes the atom read localStorage synchronously on the
// first client render instead of defaulting to `{}` and hydrating a tick later.
// Without it, a returning viewer's contactId isn't available when the public
// form's one-shot "do I have an in-progress submission?" check fires, so the
// saved answers never load and the form looks blank (a fresh restart).
export const userIdentifierAtom = atomWithStorage<{ [workspaceId: string]: string }>('userIdentifier', {}, undefined, { getOnInit: true })